import api, { useApi } from '@utils/api'
import { API_ENDPOINTS } from '@utils/api-endpoints'

export const useSWRGetUserAddresses = (userId: string) => {
  const url = `${API_ENDPOINTS.USER_ADDRESS(userId)}`
  const { data, isError, mutate, isLoading } = useApi(userId && url)
  return {
    addresses: data?.data,
    isLoading,
    isError,
    mutate,
    key: url,
  }
}

export const addUserLocation = async (userId: string, payload: any) => {
  try {
    const url = `${API_ENDPOINTS.USER_ADDRESS(userId)}`
    const { data } = await api.put(url, payload)
    return { user: { ...data } }
  } catch (error) {
    const data = {
      data: null,
      msg: 'Add Address failed',
      success: false,
    }
    return { user: { ...data } }
  }
}
